import { $api } from '../AxiosInstance';

export class TranslationAIService {
  /**
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   * @param {String} params.key
   * @param {String} params.languagePackageId
   */

  static getAllAITranslations(params) {
    return $api.post('/api/front/language-package-translations', params);
  }

  /**
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   * @param {String} params.key
   * @param {String} params.languagePackageId
   */

  static getPaginationAITranslations(params) {
    return $api.post('/api/front/language-package-translations/pagination', params);
  }

  static getTranslationAIById(id) {
    return $api.get(`/api/front/language-package-translation/${id}`);
  }

  /**
   * @param {Object} translation
   * @param {String} translation.id
   * @param {String} translation.value
   */

  static updateTranslationAiById(translation) {
    return $api.patch(`/api/front/language-package-translation/${translation?.id}`, translation);
  }

  static deleteTranslationAIById(id) {
    return $api.delete(`/api/front/language-package-translation/${id}`);
  }
}
